export enum SearchField {
  EXAM_CODE = 'examCode',
  EXAM_NAME = 'examName',
  ADMISSION_DATE = 'admissionDate',
  ADMISSION_SITE = 'admissionSite',
  REGIONAL = 'region',
  ID_TYPE = 'identificationType',
  PATIENT_ID = 'identificationNumber',
  PATIENT_FIRST_NAME = 'patientFirstName',
  PATIENT_LAST_NAME = 'patientLastName',
  SPECIMEN_ID = 'specimenId',
  CASE_NUMBER = 'caseNumber',
  ORDER_NUMBER = 'orderNumber'
}
